
const isProduction = () => (
  process.env.NODE_ENV === 'production'
)

const prodOrDevCdnParam = () => (
  isProduction() ? 'prod' : 'dev'
)

export { isProduction, prodOrDevCdnParam }